<template>
  <header class="header-m">
    <div class="header-box">
      <img src="@/assets/images/logo-2x.png" alt="" @click="changeNav({path: '/index'})">
      <div class="header-icon" @click="isShow = true">
         <a-icon type="menu" style="color: #333333; fontSize: 18px;"/>
      </div>
    </div>

    <a-drawer
      class="header-nav"
      placement="right"
      :visible="isShow"
      width="43.2vw"
      :headerStyle="{ height: '37.333vw' }"
      @close="isShow = false"
    >
      <ul>
        <li v-for="item in $store.getters.useNavList" :key="item.key" :class="item.activated || (item.path === '/business' && ['/caidaoApp', '/shopkeeperHelp'].includes($route.path)) ? 'li--activated' : ''" @click="_changeNav(item)">{{item.name}}</li>
      </ul>
    </a-drawer>
  </header>
</template>

<script>
import nav from '@/mixins/nav.js'

export default {
  name: 'header-m',

  mixins: [nav],

  data () {
    return {
      isShow: false
    }
  },

  methods: {
    _changeNav (item) {
      this.changeNav(item)
      this.isShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
.header-m {
  height: 40px;
  background: #FFFFFF;

  .header-box {
    position: relative;
    height: 100%;
    line-height: 40px;
    text-align: center;

    img {
      width: 74px;
      height: 26px;
    }

    .header-icon {
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .header-nav {
    ::v-deep .ant-drawer-close {
      color: #333;
    }

    ul {
      padding: 0;
      padding-right: 20px;
      list-style-type:none;

      li {
        width: 100%;
        margin-bottom: 46px;
        font-size: 15px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        text-align: right;
        line-height: 18px;
        cursor: pointer;
        user-select: none;

        &:hover {
          @extend .li--activated;
        }
      }

      .li--activated {
        color: $base-color;
      }
    }
  }
}
</style>
